import EditorialImage from "@/components/EditorialImage";
import Reveal from "@/components/Reveal";

const images = [
  {
    id: "own-cleared-room-01",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/3tti8qub_677f1f83-eb5c-4cd2-a678-94d373958fbb.jpeg",
    alt: "Heller, leerer Wohnraum mit Holzboden nach einer Wohnungsräumung",
    label: "EIGENE AUFNAHME · NACH DER RÄUMUNG",
  },
  {
    id: "own-cleared-room-02",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/jppsuu0b_672bfe8e-b8c7-4b95-a058-9d335c36357c.jpeg",
    alt: "Leerer Raum unter dem Dach nach einer Räumung",
    label: "EIGENE AUFNAHME · KLARER RAUM",
  },
  {
    id: "own-cleared-room-03",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/ud3c6vsi_6bbf8b23-7a1b-4b77-b111-cecac8340195.jpeg",
    alt: "Leerer Wohnraum mit Fenster und Parkett nach dem Auszug",
    label: "EIGENE AUFNAHME · BEREIT FÜR DEN NÄCHSTEN SCHRITT",
  },
  {
    id: "own-cleared-room-04",
    src: "https://customer-assets-eiarnc6j.emergentagent.net/job_umzug-markgraefler/artifacts/mr47wanv_79438ed4-be78-4349-a677-16da78e51801.jpeg",
    alt: "Leerer Raum mit Küche und Dachfenster nach einer Wohnungsräumung",
    label: "EIGENE AUFNAHME · WOHNUNGSRÄUMUNG",
  },
];

export default function ImageStorySection() {
  return (
    <section className="section visual-story-section" data-testid="image-story-section">
      <div className="container">
        <Reveal className="visual-story-heading">
          <span className="eyebrow">Eigene Einblicke · Wohnungsräumung</span>
          <h2 className="section-title">Leise Bilder.<br /><em>Klare Arbeit.</em></h2>
          <p className="section-lead">Hier sehen Sie eigene Aufnahmen aus einer Wohnungsräumung. Leere Räume nach dem Auszug – klar, ordentlich und bereit für den nächsten Schritt.</p>
        </Reveal>
        <div className="image-story-grid">
          {images.map((image, index) => (
            <Reveal key={image.id} className={`image-story-item image-story-item-${index + 1}`} delay={index * 80}>
              <article data-testid={`image-story-${image.id}`}>
                <EditorialImage src={image.src} alt={image.alt} label={image.label} testId={`image-asset-${image.id}`} />
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
